// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    let mmv = document.querySelector('.--mm');
    const spot = document.querySelector('.-spot')
    function move(e){
      /*console.log(e.offsetY); */
      
      //spot.style.setProperty('--spotlight1-x', e.offsetX + 'px');
      //spot.style.setProperty('--spotlight1-y', e.offsetY + 'px');
      
      /*spot.style.setProperty('--spotlight1-x', e.clientX + 'px');
      spot.style.setProperty('--spotlight1-y', e.clientY + 'px');*/
     const x = e.offsetX;
     const y = e.offsetY;
      gsap.to(spot, {
          '--spotlight1-x': `${x}px`,
          '--spotlight1-y': `${y}px`,
          duration: 0.5,
          ease: 'sine.out'
      })
    }

    mmv.addEventListener('mousemove', move);


    /*scrollspy*/
    document.addEventListener('DOMContentLoaded', function(){ 
      // grab the sections (targets) and menu_links (triggers)
      // for menu items to apply active link styles to
      const sections = document.querySelectorAll(".--spy");
      const menu_links = document.querySelectorAll(".--spy-nav-item a");

      // functions to add and remove the active class from links as appropriate
      const makeActive = (link) => menu_links[link].parentElement.classList.add("active");
      const removeActive = (link) => menu_links[link].parentElement.classList.remove("active");
      const removeAllActive = () => [...Array(sections.length).keys()].forEach((link) => removeActive(link));
      
      // change the active link a bit above the actual section
      // this way it will change as you're approaching the section rather
      // than waiting until the section has passed the top of the screen
      const sectionMargin = 100;
      
      // keep track of the currently active link
      // use this so as not to change the active link over and over
      // as the user scrolls but rather only change when it becomes
      // necessary because the user is in a new section of the page
      let currentActive = 0;

      // listen for scroll events
      window.addEventListener("scroll", () => {
        //console.log('k')

        const current = sections.length - [...sections].reverse().findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin ) - 1

        // only if the section has changed
        // remove active class from all menu links
        // and then apply it to the link for the current section
        if (current !== currentActive) { console.log(current)
          removeAllActive();
          currentActive = current;
          makeActive(current);
          
        }
      });
    }, false);
      

    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }
 
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;

      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        /*top: offsetTop-header,*/
        top: offsetTop,
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });
  
    /*Tiny slider services*/
    const tnsSliderServices = document.querySelectorAll('.-services-tns');
    tnsSliderServices.forEach(sliderServices => {
      const tnsSliderServices = tns({
          container: sliderServices,
          items: 1.649,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 32,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          controlsContainer: "#customize-controls",
          responsive: { 
              1366: {
                items: 1.649,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 1.649,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1.08,
                gutter: 16,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    }); 

    /*Tiny slider plans*/
    const tnsSliderPlans = document.querySelectorAll('.-plans-tns');
    tnsSliderPlans.forEach(sliderPlans => {
      const tnsSliderPlans = tns({
          container: sliderPlans,
          items: 4,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 24,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="fluent:arrow-left-12-filled"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="fluent:arrow-right-12-filled"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 4,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 1,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1.2,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    });     

    /*Tiny slider brands*/
    const tnsSliderBrands = document.querySelectorAll('.-brands-tns');
    tnsSliderBrands.forEach(sliderBrands => {
      const tnsSliderBrands = tns({
          container: sliderBrands,
          items: 7,
          nav: false,
          controls: false,
          autoplayButtonOutput: false,
          autoplay: true,
          autoplayTimeout: 2000,
          gutter: 0,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 7,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 5,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 3,
                //autoplay: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          }           
      });
    }); 

    /*Tiny slider cases*/
    const tnsSliderCases = document.querySelectorAll('.-cases-tns');
    tnsSliderCases.forEach(sliderCases => {
      const tnsSliderCases = tns({
          container: sliderCases,
          mode: 'gallery',
          animateIn: 'animate__fadeInUp',
          animateOut: 'animate__fadeOutUp',
          //animateIn: 'animate__fadeInDownBig',
          //animateOut: 'animate__backInDown',
          //animateDelay: 500,
          speed: 1000,
          items: 1,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="fluent:arrow-left-12-filled"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="fluent:arrow-right-12-filled"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 1,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 1,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    });           

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('wh_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('wh_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('wh_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('wh_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });             

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));